module.exports = __webpack_public_path__ + "img/pApple.fe4f01ad.svg";